<template>
  <div class="container">
      <div class="client-app-inc" style="height:200px" v-if="_.isEmpty(allPromotions)">
        <Loader style="margin-top:-40px"></Loader>
      </div>
      <slot v-if="!_.isEmpty(allPromotions)">
        <Menu v-if="!promotionDetail && isMobile || !isMobile" :groups="groups" @Group="activeGroup = $event" :activeGroup="activeGroup"></Menu>
        
        <div v-if="!promotionDetail && isMobile || !isMobile" class="promotion-container">
            <a @click="openPromotion(item)" class="promotion" v-for="(item,key) in promotions" :key="key">
              <img :src="$store.state.main.cdn_url + item.image">
            </a>
        </div>
        <div class="alert" style="margin: 10px 15px; padding:15px; font-weight:bold" v-if="_.isEmpty(promotions)">Promosyon bulunamadı ve ya bu kategoriye ait bir promosyon mevcut değil...</div>
        <div class="promo-modal">
          <Modal @modalStatus="promotionDetail = $event; $router.replace({ params: { id: null }}) " :isPromotion="promotionDetail" :isVisible="promotionDetail">
            <slot v-if="!_.isNull(activePromotion)">
              <template slot="img"><img :src="$store.state.main.cdn_url + activePromotion.image_first" width="400"></template>
              <template slot="info">
                   
              </template>
              <template slot="content"> <div><h3 class="line-title">{{ activePromotion.title }}</h3><div v-html="activePromotion.content"></div></div></template>
            </slot>
          </Modal>
        </div>  
      </slot>
  </div>
</template>

<script>
  import Menu from '../components/Promotions/Menu'
  export default{
      name:'Promotions',
      data(){
        return{
          promotionDetail: false,
          groups:{},
          loader: false,
          allPromotions: [],
          promotions:[],
          activePromotion:null,
          activeGroup: this.$route.params.group ? this.$route.params.group : 'all'
        }
      },
      methods:{
        openPromotion(promotion){
            this.promotionDetail = true;
            this.activePromotion = promotion;
            this.$router.replace({ params: { group: this.activeGroup, id: promotion.id }});
        },
        fetchData() {
          axios.get('/promotions', { params: { type: 'full'}})
              .then((response)=>{
                  this.allPromotions 	= !_.isEmpty(response.data.data) ? _.sortBy(response.data.data, ['sort']) : response.data.data;
                  this.promotions 	= this.allPromotions;
                  this.groups 		= response.data.other.groups;
                  this.promotions 	= !_.isEmpty(this.promotions) ? _.sortBy(this.promotions, ['sort']) : this.promotions;
                  if(this.$route.params.group){
                    this.setGroup(this.$route.params.group);
                  }
                  if(this.$route.params.id){
                    this.setPromo(this.$route.params.id, this.$route.params.group ? this.$route.params.group : 'all');
                  }
              })
              .catch((err)=>{
                  
              })

        },
        setGroup(group_id){
            this.$router.replace({ params: { group: group_id, id: this.$route.params.id ? this.$route.params.id : null }});
            this.promotions  = _.filter(this.allPromotions, o => {
                return ((_.includes(o.group_id, group_id)) || (group_id == 'all' && o.group_id == o.group_id));
            });
        },
        setPromo(promotion_id, group_id){
            this.$router.replace({ params: { group: group_id, id: promotion_id }});
            let active = _.filter(this.allPromotions, function(o) { return o.id == promotion_id; })
            this.promotionDetail = true;
            this.activePromotion = active[0];
        }
      },
      watch: {
          'activeGroup': function(group_id) {
              this.setGroup(group_id);
            this.$router.replace({ params: { group: group_id, id: null }});
          },
      },
      created(){
        this.fetchData();

      },
      components:{
        Menu
      }
  }
</script>